import React from "react";

import { Attribute } from "./Attribute";
import { IAttributesProps } from "./types";

export const Attributes: React.FC<IAttributesProps> = ({ attributes }) => (
  <>
    {attributes.map((attribute, index) => (
      <Attribute
        key={index}
        iconCode={attribute.strikedthrough ? "not-available" : attribute.entity.icon || ""}
        description={attribute.extraDescription || attribute.entity.extraDescription || undefined}
        type={attribute.entity.dataType}
        name={attribute.entity.label}
        value={attribute.value}
        format={attribute.entity.config ? attribute.entity.config.format : null}
      />
    ))}
  </>
);
